// Shared glTF loader factory.
//
// Every .glb in the game is loaded through here so the meshopt decoder is
// attached uniformly across all three run modes (no-build / dev / prod). The
// decoder is vendored at vendor/three/addons/libs/ and resolves via the
// "three/addons/" import-map prefix (mirrored by the vite alias), so this
// works on the no-build page exactly as it does in the bundle.
//
// Attaching the decoder is harmless for uncompressed .glb files: GLTFLoader
// only invokes it when an asset declares the EXT_meshopt_compression
// extension, so existing uncompressed assets (chocky.glb today) keep loading
// unchanged. This is the prerequisite for shipping meshopt-packed geometry
// (see CHOCKYTOWN DESIGN 11.md's compression pipeline).
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js';

export function makeGLTFLoader() {
  const loader = new GLTFLoader();
  loader.setMeshoptDecoder(MeshoptDecoder);
  return loader;
}
